import { initializeApp } from "firebase/app";
import { initializeAuth, browserLocalPersistence, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { initializeAppCheck, ReCaptchaEnterpriseProvider, type AppCheck } from "firebase/app-check";

const cfg = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app = initializeApp(cfg);

// App Check — activates once a reCAPTCHA Enterprise site key is configured.
// Until the key is provisioned, the admin uses Firebase's debug token path
// (set VITE_APP_CHECK_DEBUG_TOKEN in .env.local) or skips App Check if the
// backend is running with ENFORCE_APP_CHECK=false.
const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
const debugToken = import.meta.env.VITE_APP_CHECK_DEBUG_TOKEN;
export let appCheck: AppCheck | null = null;
if (siteKey) {
  if (debugToken) (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
  try {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (err) {
    console.warn("[app-check] init failed", err);
  }
}
// Use initializeAuth without popupRedirectResolver — prevents Firebase from
// attempting to load https://apis.google.com/js/api.js, which is blocked by
// the admin's script-src 'self' CSP header.
export const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
});
export const db = getFirestore(app);
export const functions = getFunctions(app, "europe-west1");

if (import.meta.env.VITE_USE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "localhost", 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
}
